var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('ci-icon',{staticClass:"!gl-border-0",attrs:{"status":_vm.statusObject,"show-status-text":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }